var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 17 9.5" },
      attrs: {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 17 9.5",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        staticClass: "st0",
        style: { fill: _vm.fill },
        attrs: {
          d: "M9.2,9.1c-0.4,0.4-1,0.4-1.4,0L0.4,1.8C0,1.4,0,0.8,0.4,0.4c0.4-0.4,1-0.4,1.4,0l6.7,6.7l6.7-6.7\n\tc0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L9.2,9.1z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/ChevronIcon.vue